import axios from 'axios';

// export const API_BASE_URL = 'http://120.79.175.101:8000';
// export const API_BASE_URL = 'http://127.0.0.1:8000';

// export const API_BASE_URL = "https://api.oneaim.fun";

// export const API_BASE_URL = 'http://192.168.79.28:8000';
// export const API_BASE_URL = 'http://192.168.79.96:8000';

// export const API_BASE_URL = 'http://192.168.0.12:8000';
// export const API_BASE_URL = 'http://192.168.101.6:8000';
export const API_BASE_URL = "https://api.ennovels.com";


export const resolveCoverUrl = (raw) => {
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.includes('xiaoshuoassets.oss-ap-southeast-1.aliyuncs.com')) return raw;
  const normalized = raw.startsWith('/') ? raw.slice(1) : raw;
  return `https://xiaoshuoassets.oss-ap-southeast-1.aliyuncs.com/images/${normalized}`;
};

// 创建axios实例
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,  // 增加到30秒，特殊请求可以单独设置更长的timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

/** 是否为应静默处理的网络/超时错误（如 admin 下的 timeout），用于跳过 alert */
export const isSilentNetworkError = (err) => {
  if (!err) return false;
  if (err.silentNetworkError === true) return true;
  const msg = err?.message || '';
  return err?.code === 'ECONNABORTED' || msg === 'Network Error' || /timeout|exceeded/i.test(msg);
};

export const withApiPrefix = (rawPath = '') => {
  const trimmed = typeof rawPath === 'string' ? rawPath.trim() : '';
  if (!trimmed) {
    return '/api';
  }
  const normalized = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  if (normalized === '/api' || normalized.startsWith('/api/')) {
    return normalized;
  }
  return `/api${normalized}`;
};

// 请求拦截器 - 添加认证token
api.interceptors.request.use(
  (config) => {
    if (typeof config.url === 'string' && !config.url.startsWith('http')) {
      config.url = withApiPrefix(config.url);
    }
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理错误
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const msg = error?.message || '';
    const isTimeoutOrNetwork =
      error.code === 'ECONNABORTED' ||
      msg === 'Network Error' ||
      /timeout|exceeded/i.test(msg);
    if (isTimeoutOrNetwork) {
      console.warn('请求超时或网络异常:', error.config?.url);
      if (typeof window !== 'undefined' && window.location?.pathname?.startsWith?.('/admin')) {
        error.silentNetworkError = true;
      }
    }

    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/';
    }

    if (error.response?.status === 429) {
      const msg = error.response.data?.detail || '请求过于频繁，请稍后再试';
      const isAdmin = typeof window !== 'undefined' && window.location?.pathname?.startsWith?.('/admin');
      if (isAdmin) {
        console.warn('请求频率超限:', msg);
      } else if (!window._rateLimitAlertShown) {
        window._rateLimitAlertShown = true;
        alert(msg);
        setTimeout(() => { window._rateLimitAlertShown = false; }, 5000);
      }
    }

    if (error.response?.status === 403) {
      const detail = error.response.data?.detail;
      if (detail && (detail.code === 'DAILY_LIMIT_REACHED' || detail.code === 'VIP_REQUIRED')) {
        window.dispatchEvent(
          new CustomEvent('vip-limit-reached', {
            detail: {
              action: detail.action || 'vip_required',
              message: detail.message,
              limit: detail.limit,
              used: detail.used,
              remaining: detail.remaining,
            },
          })
        );
      }
    }

    return Promise.reject(error);
  }
);

export default api;
